/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Payment_Edit_DescriptionInputs */

const de_billing_payment_edit_description = /** @type {(inputs: Billing_Payment_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinterlegen Sie eine neue Zahlungsmethode für zukünftige Zahlungen.`)
};

/** @type {(inputs: Billing_Payment_Edit_DescriptionInputs) => LocalizedString} */
const en_billing_payment_edit_description = de_billing_payment_edit_description;

/**

* @param {Billing_Payment_Edit_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_payment_edit_description = /** @type {((inputs?: Billing_Payment_Edit_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Payment_Edit_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_billing_payment_edit_description(inputs)
	return en_billing_payment_edit_description(inputs)
});